import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Kiosks from "./views/Kiosks.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:kiosk_slug",
      name: "Home",
      component: Home,
    },
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

export default router;
